module.exports = __webpack_public_path__ + "static/fingerprint-4a35f7145027ed05566cc0bf3783c50b.svg";